module.exports = __webpack_public_path__ + "media/components/country-flag/static/eh-ca914c191ee103691e60f95b55337bb4.svg";